var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2682 19.0625C39.4557 11.5 32.4141 7.14581 24.9974 7.14581C21.2891 7.14581 17.6849 8.22915 14.3932 10.25C11.1016 12.2916 8.14323 15.2708 5.72656 19.0625C3.64323 22.3333 3.64323 27.6458 5.72656 30.9166C10.5391 38.5 17.5807 42.8333 24.9974 42.8333C28.7057 42.8333 32.3099 41.75 35.6016 39.7291C38.8932 37.6875 41.8516 34.7083 44.2682 30.9166C46.3516 27.6666 46.3516 22.3333 44.2682 19.0625ZM24.9974 33.4166C20.3307 33.4166 16.5807 29.6458 16.5807 25C16.5807 20.3541 20.3307 16.5833 24.9974 16.5833C29.6641 16.5833 33.4141 20.3541 33.4141 25C33.4141 29.6458 29.6641 33.4166 24.9974 33.4166Z",
    fill: "#009254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.0417C21.7292 19.0417 19.0625 21.7084 19.0625 25C19.0625 28.2709 21.7292 30.9375 25 30.9375C28.2708 30.9375 30.9583 28.2709 30.9583 25C30.9583 21.7292 28.2708 19.0417 25 19.0417Z",
    fill: "#009254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketOpen);
export default __webpack_public_path__ + "static/media/ticket-open.da24d9d563caeb6d42d3f8174cb7828c.svg";
export { ForwardRef as ReactComponent };